import { IAccount } from '../interface/auth';
import { getAppRole } from './role';

// Super admin sees every admin page; staff see the pages their role grants (plus the Dashboard,
// which has no feature) and never the super-admin-only ones (Users, Roles).
export const canAccessAdminRoute = (
  user: IAccount | undefined,
  staffFeatures: string[] | undefined,
  route: { feature?: string; superAdminOnly?: boolean }
) => {
  const role = getAppRole(user);
  if (role === 'superAdmin') return true;
  if (role !== 'staff' || route.superAdminOnly) return false;
  return !route.feature || !!staffFeatures?.includes(route.feature);
};
